import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { List, Modal, Radio } from "antd";
import { Link } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import "./AppSettings.scss";
import { useState } from "react";

export const AppSettings = () => {
  const { t } = useTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const languages = [
    { code: "en", name: "English", country_code: "gb" },
    { code: "es", name: "Español", country_code: "es" },
  ];

  const data = [
    { title: t("Language_settings"), to: "" },
    { title: t("Location_settings"), to: "/settings/location" },
    {
      title: t("Account_deletion"),
      onClick: () => {
        setIsDeleteModalOpen(true);
      },
    },
  ];

  const radioData = [
    { title: t("Dark_mode"), to: "" },
    { title: t("Add_to_Home_screen"), to: "" },
  ];

  return (
    <div className="c-app-settings">
      <Modal
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={() => setIsDeleteModalOpen(false)}
        title={t("delete_account.title")}
      >
        <p>{t("delete_account.description")}</p>
      </Modal>
      <div className="c-app-settings-header">
        <Link to={"/home-page"}>
          <ArrowLeftOutlined
            style={{ color: "black" }}
            className="c-app-settings-header-image"
          />
        </Link>
        <label className="c-app-settings-header-label">
          {t("App_settings")}
        </label>
      </div>
      <List
        itemLayout="horizontal"
        dataSource={data}
        className="c-store-panel_list"
        renderItem={(item, index) => (
          <List.Item onClick={() => item?.onClick?.()}>
            <List.Item.Meta
              title={<Link to={item?.to || "#"}>{item.title}</Link>}
            />
            <ArrowRightOutlined />
          </List.Item>
        )}
      />
      <List
        itemLayout="horizontal"
        dataSource={radioData}
        className="c-store-panel_list"
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta title={item.title} />
            <Radio disabled={true} className="c-app-settings-radio" />
          </List.Item>
        )}
      />
      <div id="translate">
        {languages.map((lang) => (
          <>
            <span
              key={lang.code}
              onClick={() => {
                i18n.changeLanguage(lang.code);
              }}
            >
              <img
                src={`/assets/flags/${lang.country_code}.svg`}
                alt="flag"
                style={{ width: 50, height: 30 }}
              />
              <span>{lang.name}</span>
            </span>
            <br />
          </>
        ))}
      </div>
    </div>
  );
};
